import { SHARED_ROUTES } from '@aibees/shared/constants';
import { classnames } from '@aibees/shared/utils';
import {
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DialogTitle } from '../dialog-title';
import { upgradeIncludes } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { BulkLimitDialogProps as Props } from './types';

export const BulkLimitDialog = memo(
  ({ className, state, imgSrc, title }: Props) => {
    const navigate = useNavigate();

    const handleUpgrade = () => {
      state.onFalse();
      navigate(SHARED_ROUTES.priceAndPlan);
    };

    return (
      <Styled.Wrapper
        open={state.value}
        onClose={state.onFalse}
        className={classnames('BulkLimitDialog', className)}
        sx={SX.root}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle title={title} icon="problem" onClose={state.onFalse} />
        <DialogContent>
          <Stack gap={1}>
            <Styled.Image src={imgSrc} />
            {upgradeIncludes.map((item) => (
              <Stack
                key={item.title}
                direction="row"
                alignItems="flex-start"
                gap={1}
                sx={SX.stack}
              >
                <Typography
                  variant="body4"
                  fontWeight={700}
                  color="grey.700"
                  sx={{ minWidth: '140px', flexShrink: 0 }}
                >
                  {item.title}
                </Typography>
                <Typography variant="body4" fontWeight={500} color="grey.700">
                  {item.description}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" justifyContent="space-between" width="100%">
            <Button
              variant="outlined"
              color="default"
              size="small"
              onClick={state.onFalse}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleUpgrade}
            >
              🚀 Upgrade Now
            </Button>
          </Stack>
        </DialogActions>
      </Styled.Wrapper>
    );
  }
);

BulkLimitDialog.displayName = 'BulkLimitDialog';
